import React from 'react'

const ShortDesc = ({desc,textLink,link}) => {
  return (
    <div className="descAppBox">
      <p>{desc} <a style={{ color:'blueviolet' }} href={link}><b><u>{textLink}</u></b></a></p>
    </div>
  )
}

export default ShortDesc
